import { palette } from '../styles/theme';

export function getColor (colorName, tone = 'main', alpha = null) {
    let resolvedColorValue = null;

    if (!Object.prototype.hasOwnProperty.call(palette, colorName)) {
        console.warn(`JS: Color '${colorName}' no encontrado en la paleta.`);
    }
    else {
        const colorShades = palette[colorName];
        if (Object.prototype.hasOwnProperty.call(colorShades, tone)) {
            resolvedColorValue = colorShades[tone];
        }
        else {
            console.warn(`JS: Tono '${tone}' no encontrado para el color '${colorName}'. Intentando usar el tono 'main' como fallback.`);
            if (Object.prototype.hasOwnProperty.call(colorShades, 'main')) {
                console.warn(`JS: Usando tono 'main' como fallback para '${colorName}'.`);
                resolvedColorValue = colorShades.main;
            }
            else {
                console.warn(`JS: Tono 'main' tampoco encontrado para '${colorName}'.`);
            }
        }
    }

    if (resolvedColorValue !== null) {
        if (alpha !== null && typeof alpha === 'number' && alpha >= 0 && alpha <= 1) {
            // Convertir HEX a RGBA
            let r = 0; let g = 0; let b = 0;
            if (resolvedColorValue.startsWith('#')) {
                const hex = resolvedColorValue.slice(1);
                if (hex.length === 3) { // Formato #RGB
                    r = parseInt(hex[0] + hex[0], 16);
                    g = parseInt(hex[1] + hex[1], 16);
                    b = parseInt(hex[2] + hex[2], 16);
                }
                else if (hex.length === 6) { // Formato #RRGGBB
                    r = parseInt(hex.substring(0, 2), 16);
                    g = parseInt(hex.substring(2, 4), 16);
                    b = parseInt(hex.substring(4, 6), 16);
                }
                else {
                    console.warn(`JS: Formato de color HEX '${resolvedColorValue}' no reconocido para aplicar alfa. Se devuelve el color base.`);
                    return resolvedColorValue;
                }
                return `rgba(${r}, ${g}, ${b}, ${alpha})`;
            }
            else {
                console.warn(`JS: El valor del color '${resolvedColorValue}' no es un HEX válido. Se devuelve el color base.`);
                return resolvedColorValue; // Si no es un color HEX, no podemos procesarlo fácilmente a rgba
            }
        }
        else if (alpha !== null) {
            console.warn(`JS: Valor alfa inválido: ${alpha}. Debe ser un número entre 0 y 1. Se devuelve el color base.`);
            return resolvedColorValue; // Devuelve el color base si alfa es inválido
        }
        else {
            return resolvedColorValue; // Devuelve el color base si no se especifica alfa
        }
    }

    console.warn(`JS: No se pudo resolver el color para '${colorName}' con tono '${tone}'.`);
    return null; // O un string como 'transparent' o un color de error
}
